export default "__VITE_ASSET__DCjE7Nys__"